module.exports = __webpack_public_path__ + "img/icon_web03_zizhi1@2x.27eefee7.png";